/* Chula — reveal safety net + first-screen pass
 *
 * Extracted from snippets/chula-reveal-safety.liquid on 2026-09-20.
 *
 * It was an inline <script>: re-sent and re-parsed on every page, never
 * cached. As an asset it is fetched once, cached for the session, and
 * `defer` keeps it off the parser's critical path. Deferred scripts run
 * BEFORE DOMContentLoaded, so any global defined here still exists by the
 * time the handlers and DOMContentLoaded callers that use it run.
 */

(function () {
    'use strict';
    if (window.chulaRevealNetBound) return;
    window.chulaRevealNetBound = true;

    var DELAY = 2500;      // well past any honest observer
    var MARGIN = 120;      // treat just-below-the-fold as on screen
    var pending = null;

    /* Attribute names are per-section (data-cht-reveal, data-cao-reveal, …),
       so there is no single selector to query. Walking the document once, at
       idle, is cheaper than maintaining a hardcoded list that silently stops
       covering any section added later. */
    function collect() {
      var out = [];
      var all = document.getElementsByTagName('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.classList.contains('is-in')) continue;
        var attrs = el.attributes;
        for (var j = 0; j < attrs.length; j++) {
          var n = attrs[j].name;
          if (n.length > 12 && n.indexOf('data-') === 0 && n.slice(-7) === '-reveal') {
            out.push(el);
            break;
          }
        }
      }
      return out;
    }

    function onScreen(el) {
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return false;   // not laid out
      return r.top < (window.innerHeight || 0) + MARGIN && r.bottom > -MARGIN;
    }

    function sweep() {
      if (!pending || !pending.length) return true;
      var left = [];
      for (var i = 0; i < pending.length; i++) {
        var el = pending[i];
        if (el.classList.contains('is-in')) continue;      // an observer got it
        if (onScreen(el)) el.classList.add('is-in');
        else left.push(el);
      }
      pending = left;
      return pending.length === 0;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (sweep()) window.removeEventListener('scroll', onScroll);
      });
    }

    /* ── The first screen does not wait ────────────────────────────────
       The net below is a LAST resort: it runs 2500ms after `load`, which on
       this site has been measured at 6.7s on the homepage — nine seconds
       before anything it catches becomes visible.

       That is fine for its purpose (catching a dead observer) and useless for
       the thing customers actually see: content sitting at `opacity: 0` in
       the FIRST SCREEN while the section's own inline script waits its turn
       behind ~180 KB of other inline JavaScript. The page looks half-loaded.

       So: at DOMContentLoaded, anything already in the viewport is revealed
       here, without waiting for its section. The entrance still plays — this
       adds the same `is-in` class the observers add, so the CSS transition
       runs from here instead of from a script that has not been reached yet.
       Below-the-fold content is untouched and still animates on scroll, which
       is the whole point of it.

       The image gate is kept. chula-reveal.liquid learned the hard way that
       revealing a container before its <img> can be painted animates an empty
       frame, so this waits for the images inside an element to be paintable —
       or 250ms, whichever comes first. A slow image must never hold the first
       screen. */
    function whenPaintable(el, done) {
      var all = el.tagName === 'IMG' ? [el] : el.querySelectorAll('img');
      var imgs = [];
      for (var i = 0; i < all.length; i++) {
        if (!all[i].closest || !all[i].closest('video')) imgs.push(all[i]);
      }
      if (!imgs.length) { done(); return; }

      var settled = false, waiting = imgs.length;
      function finish() {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        done();
      }
      var timer = window.setTimeout(finish, 250);
      function one() { waiting -= 1; if (waiting <= 0) finish(); }

      for (var j = 0; j < imgs.length; j++) {
        var img = imgs[j];
        if (img.complete && img.naturalWidth > 0) { one(); continue; }
        if (typeof img.decode === 'function') img.decode().then(one, one);
        else {
          img.addEventListener('load', one, { once: true });
          img.addEventListener('error', one, { once: true });
        }
      }
    }

    function revealFirstScreen() {
      try {
        var all = collect();
        for (var i = 0; i < all.length; i++) {
          (function (el) {
            if (!onScreen(el)) return;
            whenPaintable(el, function () { el.classList.add('is-in'); });
          })(all[i]);
        }
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealFirstScreen);
    } else {
      revealFirstScreen();
    }

    function start() {
      window.setTimeout(function () {
        try {
          pending = collect();
          if (!pending.length) return;
          if (sweep()) return;
          /* A scroll listener rather than another observer: if the reason we
             are here is that IntersectionObserver is not reporting on this
             device, a second observer would fail the same way. */
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll, { passive: true });
        } catch (e) {}
      }, DELAY);
    }

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  })();
